
export const API_URL = process.env.REACT_APP_API_URL;

export const WIKIPEDIA_API_URL = 'https://en.wikipedia.org/w/api.php?';